module.exports = __webpack_public_path__ + "img/xiecheng@2X.b3ae38a0.png";